import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "wyatt-message",
  class WyattMessage extends WYATTElement {
    constructor() {
      super();

      this.dismissButton = this.querySelector("[data-dismiss]");

      if (this.dismissButton) {
        this.dismissButton.addEventListener(
          "click",
          this.handleDismissClick.bind(this),
        );
      }
    }

    handleDismissClick(event) {
      event.preventDefault();
      event.stopPropagation();

      this.dismiss();
    }

    dismiss() {
      this.setAttribute("removing", true);
      this.addEventListener("transitionend", () => this.remove());
    }
  },
);
